const ENABLED_KEY = "et.notifications.enabled";
const ONLY_HIDDEN_KEY = "et.notifications.onlyWhenHidden";

export const getNotificationPrefs = () => {
  if (typeof window === "undefined") return { enabled: false, onlyWhenHidden: true };

  const enabled = window.localStorage.getItem(ENABLED_KEY) === "true";
  const onlyWhenHidden = window.localStorage.getItem(ONLY_HIDDEN_KEY) !== "false";
  return { enabled, onlyWhenHidden };
};

export const setNotificationPrefs = (input: { enabled: boolean; onlyWhenHidden: boolean }) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ENABLED_KEY, String(input.enabled));
  window.localStorage.setItem(ONLY_HIDDEN_KEY, String(input.onlyWhenHidden));
};

const truncate = (s: string, max = 140) => (s.length > max ? `${s.slice(0, max - 1)}…` : s);

export const showBrowserNotification = async (input: {
  title: string;
  body?: string;
  tag?: string;
  url: string;
}) => {
  if (typeof window === "undefined") return;
  if (!("Notification" in window)) return;
  if (Notification.permission !== "granted") return;

  const registration = await navigator.serviceWorker?.ready.catch(() => null);
  const body = input.body ? truncate(input.body) : undefined;

  // Prefer SW notifications (better support on installed PWAs).
  if (registration?.showNotification) {
    await registration.showNotification(input.title, {
      body,
      tag: input.tag,
      icon: "/icons/icon-192.png",
      badge: "/icons/icon-192.png",
      data: { url: input.url },
    });
    return;
  }

  const n = new Notification(input.title, {
    body,
    tag: input.tag,
    icon: "/icons/icon-192.png",
    data: { url: input.url },
  } as any);

  n.onclick = () => {
    window.focus();
    window.location.href = input.url;
    n.close();
  };
};

